export type PendingSeverity = 'urgent' | 'high' | 'medium' | 'low' | 'info';

export interface PendingItem {
  key: string;
  count: number;
  severity: PendingSeverity;
}

export interface DashboardOverview {
  kpis: {
    revenueThisMonth: number;
    openProcesses: number;
    overdueAmount: number;
    overdueCount: number;
    quotesConvertedThisMonth: number;
    quoteConversionRate: number;
  };
  pending: PendingItem[];
  charts: {
    revenue: { month: string; paid: number; open: number }[];
    intake: { month: string; nif: number; visa: number; residence: number }[];
    quoteFunnel: { status: string; count: number }[];
    paymentStatus: { status: string; count: number; total: number }[];
  };
  leads: LeadsOverview;
}

export interface LeadsOverview {
  kpis: {
    quizThisMonth: number;
    quizConversionRate: number;
    crmOpen: number;
    crmNegotiation: number;
    clicksThisMonth: number;
  };
  charts: {
    monthly: { month: string; vip: number; qualified: number; nurture: number; crm: number }[];
    quizFunnel: { status: string; count: number }[];
    crmFunnel: { status: string; count: number }[];
  };
  sources: {
    landings: { slug: string; clicks: number; leads: number; converted: number }[];
    campaigns: { source: string; campaign: string; leads: number; converted: number }[];
    crmOrigins: { origin: string; count: number }[];
  };
}

export const formatEuro = (value: number, lang: string, compact = false) =>
  new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: 'EUR',
    notation: compact ? 'compact' : 'standard',
    maximumFractionDigits: compact ? 1 : 2,
  }).format(value);

// "2026-10" → "out/26" no idioma atual
export const formatMonth = (month: string, lang: string) => {
  const [year, m] = month.split('-').map(Number);
  return new Intl.DateTimeFormat(lang, { month: 'short', year: '2-digit' }).format(new Date(year, m - 1, 1));
};
